import { useMobxStores } from '@/stores';
import ReservationStore from '@/stores/ReservationStore';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';

function mapMessage(s: string): string {
  if (s?.startsWith('Checkout: ')) {
    return s.substring(10);
  }
  return s;
}

const ReserveNowButton = ({
  facility,
  handleChangeDatesModal,
  handleConfirmSetDateTimeModal,
  showText = true,
  extraClass = '',
}) => {
  const { reservationStore }: { reservationStore: ReservationStore; } =
    useMobxStores();
  // facility_open_time = min_hours_reservation (database)
  const arr_warnings =
    reservationStore.bookingPriceDetail?.validate_warnings;
  const arr_infos = reservationStore.bookingPriceDetail?.validate_infos;

  return (
    <>
      {reservationStore.facilityStatus === 'unavailable' && showText && (
        <div className="flex flex-col my-2 md:w-full">
          <>
            {facility.facility_min_days > 0 && facility.facility_max_days > 0 && (
              <p className="text-center mb-2">
                <span className="text-center">
                  This facility requires a minimun of{' '}
                  <strong>{facility.facility_min_days}</strong> and max of{' '}
                  <strong>{facility.facility_max_days}</strong> days. Change the
                  dates!
                </span>
              </p>
            )}
            {facility.facility_max_days === 0 &&
              facility.facility_min_days > 0 && (
                <p className="text-center mb-2">
                  <span className="text-center">
                    This facility requires a minimum of{' '}
                    <strong>{facility.facility_min_days}</strong> days. Change
                    the dates!
                  </span>
                </p>
              )}
            {facility.facility_min_days === 0 &&
              facility.facility_max_days > 0 && (
                <p className="text-center mb-2">
                  <span className="text-center">
                    This facility requires a max of{' '}
                    <strong>{facility.facility_max_day}</strong> days. Change
                    the dates!
                  </span>
                </p>
              )}
          </>
          <Button
            onClick={handleChangeDatesModal}
            type="primary"
            size="large"
            className={`uppercase ${extraClass} bg-primary rounded-full text-sm font-bold`}
          >
            Change the dates
          </Button>
        </div>
      )}

      {reservationStore.facilityStatus === 'soldout' && showText && (
        <div className="flex flex-col my-2 md:w-full">
          <p className="text-center mb-2">
            <span className="text-center">
              This facility is sold out for this period. Change the dates!
            </span>
          </p>

          <Button
            onClick={handleChangeDatesModal}
            type="primary"
            size="large"
            className={`uppercase ${extraClass} bg-primary rounded-full text-sm font-bold`}
          >
            Change the dates
          </Button>
        </div>
      )}

      {reservationStore.facilityStatus === 'unavailablewarnings' && showText && (
        <div className="flex flex-col my-2 md:w-full">
          {arr_warnings.map((warning) => {
            return (
              <p className="text-center my-1" key={warning.key}>
                <span className="text-center">
                  {mapMessage(warning.detail)}
                </span>
              </p>
            );
          })}
          <Button
            onClick={handleChangeDatesModal}
            type="primary"
            size="large"
            className={`uppercase ${extraClass} bg-primary rounded-full text-sm font-bold`}
          >
            Change the dates!!
          </Button>
        </div>
      )}
      {reservationStore.facilityStatus === 'default' && (
        <div className="flex flex-col my-2 w-48 md:w-full">
          {arr_infos.map((info) => {
            return (
              <p className="text-center my-1" key={info.key}>
                <span className="text-center">{info.detail}</span>
              </p>
            );
          })}
          <Button
            onClick={handleConfirmSetDateTimeModal}
            type="primary"
            size="large"
            className={`uppercase ${extraClass} bg-primary rounded-full text-sm font-bold`}
          >
            Reserve Now
          </Button>
        </div>
      )}
    </>
  );
};

export default observer(ReserveNowButton);

